<template>
  <div v-loading="loading_voucher">
    <div v-if="vouchers.length > 0">
      <div class="row mt-5"  v-for="(voucher,index) in vouchers" :key="index+colorCode"
           :style="{ border: `solid 1px ${colorCode}` }">
        <div class="col-md-3">
          <div style="width:95px ; height:100%; position: relative; "
               class="  d-flex align-items-center justify-content-center"
               :style="{ border: `solid 1px ${colorCode}`, backgroundColor : `${colorCode}`}"
          >
            <div class="mt-4 " v-if="voucher.type == 0" style="width: fit-content; text-align: center !important;">
              <img alt="" src="../../../../assets/img/imgVoucher.png">
              <p class="mt-2" style="color: white ; font-size: 13px">Voucher</p>
            </div>
            <div v-else class="mt-4 text-center " style="width: fit-content ; text-align: center !important;">
              <img alt="" src="../../../../assets/img/imgGift.png">
              <p class="mt-2" style="color: white ; font-size: 13px">Quà tặng</p>
            </div>
          </div>
        </div>
        <div class="col-md-6 mt-5">
          <div >
            <span style="font-weight: bold">{{voucher.name}}</span>
          </div>
          <div style="width: fit-content;font-size: 12px;padding: 5px;border-radius: 4px;color: white" class="mt-2"
               :style="{ backgroundColor : `${colorCode}`}" v-if="+voucher.value > 0">
            <span v-if="voucher.unit === 1 ">Giảm: {{ voucher.value | toThousandFilter }} ₫</span>
            <span v-else>Giảm: {{ voucher.value }} %</span>
          </div>
          <div class="mt-2">
            <img alt="" src="../../../../assets/img/imgTime.png">
            <span style="position: relative;top: 2px;left: 5px">Hiệu lực đến: {{voucher.end_date}}</span>
          </div>
          <div class="mt-2">
            <a href="javascript:" @click="showVoucherDetail(voucher)"><strong>Xem chi tiết</strong></a>
          </div>
        </div>
        <div class="col-md-3 mt-5" v-if="voucher.type == isVoucher">
          <button v-if="!voucher.selected" type="button" class="btn btn-outline-primary"
          :class="{'btn-outline-secondary':voucher.hidden}" :disabled="voucher.hidden" @click="applyVoucher(voucher)"
                  >
            Áp dụng
          </button>
          <button v-if="voucher.selected" type="button"  class="btn btn-danger" @click="cancelVoucher(voucher)">Hủy áp
            dụng
          </button>
        </div>
        <div class="col-md-3 mt-5" v-else>
          <button v-if="!voucher.selected" type="button" class="btn btn-primary"
                  :class="{'btn-secondary':voucher.hidden}" :disabled="voucher.hidden"
                  @click="applyVoucher(voucher)">Áp dụng
          </button>
          <button  v-if="!voucher.selected && +voucher.value > 0" type="button" class="btn btn-outline-primary my-3"
                   :class="{'btn-outline-secondary':voucher.hidden}" :disabled="voucher.hidden"
                   @click="changeVoucher(voucher)"
                   >Quy đổi voucher
          </button>
          <button v-if="voucher.selected" type="button" @click="cancelVoucher(voucher)" class="btn btn-danger">Hủy áp
            dụng
          </button>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="text-center w-100 center_important">
          <span class="text-danger">Không có voucher
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {DIGITAL, FLASH_SALE, PERIODIC_PROMOTIONS, SCHOOL_LINK} from "@/core/option/contractOption";
import {OTHER_SCHOOL} from "@/core/option/contractOption";

export default {
  name: "ListPromotions",
  props : {
    vouchers: {
      type: Array,
      default: () => { return [] }
    },
    id_voucher_disable: {
      type: Array,
      default: () => { return [] }
    },
    colorCode: {
      type: String,
      default() {
        return '';
      }
    },
    allCode: {
      type: Object,
      default() {
        return {}
      }
    },
    type: {
      type: Number,
      default() {
        return null
      }
    },

    loading_voucher: {
      type: Boolean,
      default() {
        return false
      }
    }

  },
  data(){
    return {
      SCHOOL_LINK:SCHOOL_LINK,
      FLASH_SALE:FLASH_SALE,
      PERIODIC_PROMOTIONS:PERIODIC_PROMOTIONS,
      isGift:3,
      isVoucher:0
    }
  },
  methods: {
    showVoucherDetail(voucher) {
      this.$emit('showVoucherDetail', voucher);
    },

    applyVoucher(voucher, isUseGift = true) {
      voucher.selected = !voucher.selected
      voucher.isUseGift = voucher.type == this.isGift ? isUseGift : false
      this.$emit('setListVoucherForContract')

    },

    changeVoucher(voucher) {
        voucher.selected = true;
        voucher.isUseGift = false;
        voucher.hidden = false;
        this.$emit('setListVoucherForContract');
        this.allCode[this.type].forEach((code) => {
          code.isUseGift = false
        });
    },

    cancelVoucher(voucher) {
      voucher.hidden = false;
      voucher.selected = false;
      voucher.isUseGift = voucher.type == this.isGift ? true : false
      this.$emit('setListVoucherForContract', voucher);
    }
  }
}
</script>

<style scoped>

</style>
